import { handleAmplitudeExperimentReset } from '@/util/amplitude/analyticsServer';
import { getCookieValue } from '@/util/cookies';
import { isImpersonating as checkImpersonating, clearImpersonatingCookie, IMPERSONATING_COOKIE } from '@/util/impersonation';
import { clientSupabase } from '@/util/supabase';
import { exitImpersonation } from './impersonation';

async function requestServerSignOut(args?: { deleted?: boolean; impersonating?: boolean }): Promise<string | null> {
  const response = await fetch('/api/auth/signout', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      next: window.location.pathname,
      deleted: args?.deleted === true,
      impersonating: args?.impersonating === true,
    }),
  });

  if (!response.ok) {
    return null;
  }

  const data = (await response.json()) as { redirectUrl?: string };
  return typeof data.redirectUrl === 'string' ? data.redirectUrl : null;
}

export const handleSignOut = async (args?: { deleted: boolean }) => {
  const isImpersonating = checkImpersonating(getCookieValue(IMPERSONATING_COOKIE));
  handleAmplitudeExperimentReset();

  if (isImpersonating) {
    const { restored } = await exitImpersonation();
    if (restored) {
      window.location.href = '/tools';
      return;
    }
    clearImpersonatingCookie();
  }

  const fallbackRedirectUrl = `/auth/signin?next=${window.location.pathname}${args?.deleted ? '&deleted=true' : ''}`;
  let redirectUrl = fallbackRedirectUrl;

  try {
    const serverRedirectUrl = await requestServerSignOut({
      deleted: args?.deleted,
      impersonating: isImpersonating,
    });

    if (serverRedirectUrl) {
      redirectUrl = serverRedirectUrl;
    } else {
      await clientSupabase.auth.signOut({ scope: args?.deleted ? 'global' : 'local' });
    }
  } catch {
    try {
      await clientSupabase.auth.signOut({ scope: args?.deleted ? 'global' : 'local' });
    } catch {
      // cookies may still be stale; navigation to sign-in remains the best UX
    }
  } finally {
    window.location.href = redirectUrl;
  }
};
